import styled from 'styled-components/macro';

export const TitleCreditCard = styled.div`
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: 1.4rem;
  width: 15.6rem;
`;
